<template>
    <div id="removeclass">
      <app-modal
        :modal-id="modalId"
        modal-alignment="top"
        modal-size="fullscreen"
        @close-modal="closeModal"
      >
      <!-- <template slot="header">
          <h5 class="modal-title">{{modalTitle}}</h5>
      </template> -->
      <template slot="body">
        <div class="container" v-html="certificate">

        </div>
        <div class="text-center">
            <pre>{{ disclaimer }}</pre>
        </div>
        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary mr-2"
            data-dismiss="modal"
            @click="closeModal">
            {{ $t("close") }}
          </button>
          <a :href="'/admin/certificate/pdf/'+this.company_certificate_id+'?company_id='+this.company_id+'&assigned_to='+assignedTo" class="btn btn-primary">Download</a>
        </div>
        </template>
        <!-- <template slot="footer">
          <button
            type="button"
            class="btn btn-secondary mr-2"
            data-dismiss="modal"
            @click="closeModal">
            {{ $t("close") }}
          </button>
          <a :href="'/admin/certificate/pdf/'+id" class="btn btn-primary">Download</a>
        </template> -->
      </app-modal>
    </div>
  </template>
  
  <script>
  import {ModalMixin} from "@/app/Mixins/ModalMixin";
  import {axiosGet} from "@/app/Helpers/AxiosHelper";
  import {CERTIFICATE_VIEW} from "@/app/Config/ApiUrl";

  export default {
    name: "CertificateViewModal",
    mixins: [ ModalMixin],
    props: {
      company_certificate_id: Number,
      company_id: Number,
      assignedTo: {type: Number, default: null}
    },
    data() {
      return {
        certificate: '',
        disclaimer: '',
        modalId: "certificate-view-Modal",
        // modalTitle: this.$t("attach_generated_documnent"),
      };
    },
    
    methods: {
       getCertificate() {
        axiosGet(CERTIFICATE_VIEW+'/'+this.company_certificate_id+'?company_id='+this.company_id)
          .then((res) => {
            this.certificate = res.data.result.view;
            this.disclaimer = res.data.result.disclaimer;
          })
          .catch((error) => {
            
          });
      },
    },
    mounted() {
      this.getCertificate();
      // $(function () {
      //   $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
      // });
    },
  };
  </script>
  